import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "lg:container lg:mx-auto" }
const _hoisted_2 = { class: "grid grid-cols-1 lg:grid-cols-3 gap-y-8 gap-x-0 lg:gap-x-8 mt-12" }
const _hoisted_3 = { class: "col-span-2 order-2 lg:order-1" }
const _hoisted_4 = { class: "grid grid-cols-1 gap-y-8" }
const _hoisted_5 = { class: "text mb-2 text-4xl" }
const _hoisted_6 = { class: "px-1 lg:px-0" }
const _hoisted_7 = { class: "px-1 lg:px-0" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { class: "grid grid-cols-4 sm:grid-cols-3 xl:grid-cols-3 gap-4" }
const _hoisted_10 = /*#__PURE__*/_createStaticVNode("<p class=\"text-gray-300 mt-4\"> *The predicted price is an estimation assuming no additional buyers or sellers. </p><p class=\"text-gray-300\"><span class=\"font-bold\">Note</span>: Users can both <span class=\"font-bold text-green-500\">BUY</span> and <span class=\"font-bold text-red-500\">SELL</span> during this event. Please be careful. </p>", 2)
const _hoisted_12 = { class: "order-1 lg:order-2 px-1 lg:px-0" }
const _hoisted_13 = { class: "pb-2 pt-20 relative" }
const _hoisted_14 = {
  key: 0,
  class: "flex absolute top-0 right-0 items-center"
}
const _hoisted_15 = { key: 1 }
const _hoisted_16 = {
  key: 1,
  class: "mt-8"
}

import { computed, ref, watch } from 'vue';
import usePoolQuery from '@/composables/queries/usePoolQuery';
import useWeb3 from '@/services/web3/useWeb3';
import useApp from '@/composables/useApp';
import LbpTradeCard from '@/embr/lbp/components/TradeCard/LgeTradeCard.vue';
import LbpStatCards from '@/embr/lbp/components/LbpStatCards.vue';
import LbpDetailWarning from '@/embr/lbp/components/LbpDetailWarning.vue';
import LgeChart from '@/embr/lbp/components/LgeChart.vue';
import { useRoute } from 'vue-router';
import useLgeQuery from '@/embr/lbp/composables/useLgeQuery';
import LgeDetailStatusBanner from '@/embr/lbp/components/LgeDetailStatusBanner.vue';
import BalLoadingBlock from '@/components/_global/BalLoadingBlock/BalLoadingBlock.vue';
import useTokens from '@/composables/useTokens';
import { getAddress } from '@ethersproject/address';
import BalTabs from '@/components/_global/BalTabs/BalTabs.vue';
import LgeDetailProjectDetails from '@/embr/lbp/components/LgeDetailProjectDetails.vue';
import Swaps from '@/components/contextual/pages/pool/PoolTransactionsCard/PoolSwaps/Swaps.vue';
import LbpDetailMultisigWarning from '@/embr/lbp/components/LbpDetailMultisigWarning.vue';
import LgeDetailAdmin from '@/embr/lbp/components/LgeDetailAdmin.vue';
import useLge from '@/embr/lbp/composables/useLge';
import {
  POOLS_ROOT_KEY,
  SWAPS_ROOT_KEY,
  TOKEN_PRICES_ROOT_KEY
} from '@/embr/constants/queryKeys';
import { useQueryClient } from 'vue-query';
import LgeSwapsTable from '@/embr/lbp/components/LgeSwapsTable.vue';


export default _defineComponent({
  setup(__props) {

const { account } = useWeb3();
const route = useRoute();
const { injectTokens, tokens } = useTokens();
const queryClient = useQueryClient();

const poolQuery = usePoolQuery(route.params.id as string);
const pool = computed(() => {
  return poolQuery.data.value;
});

const { data } = useLgeQuery(ref(route.params.id as string));

const lge = computed(() => data.value);

/**
 * COMPOSABLES
 */
const { blockNumber } = useWeb3();

const swapEnabled = computed(() => pool.value?.swapEnabled);
const launchToken = computed(() =>
  lge.value ? tokens.value[getAddress(lge.value.tokenContractAddress)] : null
);

const isUserAdmin = computed(
  () => account.value.toLowerCase() === lge.value?.adminAddress.toLowerCase()
);

const tabs = computed(() => [
  { value: 'details', label: `${lge.value?.name || ''} Details` },
  { value: 'swaps', label: 'Swap History' }
]);

const activeTab = ref(tabs.value[0].value);

watch(lge, () => {
  if (lge.value) {
    injectTokens([getAddress(lge.value.tokenContractAddress)]);
  }
});

/**
 * WATCHERS
 */
watch(blockNumber, () => {
  refetchData();
});

function refetchData() {
  poolQuery.refetch.value();
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(lge))
      ? (_openBlock(), _createBlock(LgeDetailStatusBanner, {
          key: 0,
          lge: _unref(lge)
        }, null, 8, ["lge"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(LbpDetailWarning),
      (_unref(lge) && !_unref(lge).adminIsMultisig)
        ? (_openBlock(), _createBlock(LbpDetailMultisigWarning, { key: 0 }))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", null, [
              _createElementVNode("h2", _hoisted_5, _toDisplayString(_unref(lge)?.name), 1)
            ]),
            _createElementVNode("div", _hoisted_6, [
              (_unref(lge) && _unref(pool))
                ? (_openBlock(), _createBlock(LgeChart, {
                    key: 0,
                    lge: _unref(lge),
                    pool: _unref(pool)
                  }, null, 8, ["lge", "pool"]))
                : (_openBlock(), _createBlock(BalLoadingBlock, {
                    key: 1,
                    class: "h-96"
                  }))
            ]),
            _createElementVNode("div", _hoisted_7, [
              (!_unref(lge) || !_unref(pool))
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, (n) => {
                        return _createVNode(BalLoadingBlock, {
                          key: n,
                          class: "h-28"
                        })
                      }), 64))
                    ])
                  ]))
                : (_openBlock(), _createBlock(LbpStatCards, {
                    key: 1,
                    lge: _unref(lge),
                    pool: _unref(pool)
                  }, null, 8, ["lge", "pool"])),
              _hoisted_10
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            (!_unref(lge) || !_unref(pool) || !_unref(launchToken))
              ? (_openBlock(), _createBlock(BalLoadingBlock, {
                  key: 0,
                  class: "h-96"
                }))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  (_unref(isUserAdmin))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                        _createVNode(LgeDetailAdmin, {
                          lge: _unref(lge),
                          pool: _unref(pool),
                          onAdmiEvent: _cache[0] || (_cache[0] = ($event: any) => (refetchData()))
                        }, null, 8, ["lge", "pool"])
                      ]))
                    : _createCommentVNode("", true),
                  _createVNode(LbpTradeCard, {
                    "swap-enabled": _unref(swapEnabled),
                    lge: _unref(lge),
                    pool: _unref(pool)
                  }, null, 8, ["swap-enabled", "lge", "pool"])
                ], 64))
          ])
        ])
      ]),
      (_unref(lge) && _unref(pool))
        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
            _createVNode(BalTabs, {
              modelValue: activeTab.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (activeTab.value = $event)),
              tabs: _unref(tabs),
              "no-pad": "",
              class: "-mb-px mt-24"
            }, null, 8, ["modelValue", "tabs"]),
            (_unref(lge) && _unref(pool) && activeTab.value === 'details')
              ? (_openBlock(), _createBlock(LgeDetailProjectDetails, {
                  key: 0,
                  lge: _unref(lge),
                  pool: _unref(pool)
                }, null, 8, ["lge", "pool"]))
              : _createCommentVNode("", true),
            (activeTab.value === 'swaps')
              ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                  _createVNode(LgeSwapsTable, {
                    lge: _unref(lge),
                    pool: _unref(pool)
                  }, null, 8, ["lge", "pool"])
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}
}

})